export * from './DocumentMultiImage';
